module.exports = __webpack_public_path__ + "static/media/flow-jump-mobile-en.1e0c9bb4.png";